function createScrollSection(section, gsap) {
    const pinnedImage = section.querySelector('.spv-campaignPage__scrollytell-block-image-wrapper');
    const scrollContent = section.querySelector('.spv-campaignPage__scrollytell-block-items');
    const contentItems = section.querySelectorAll('.spv-campaignPage__scrollytellItemBlock-container');
    if (!pinnedImage || !scrollContent || !contentItems.length)
        return;
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: 'top top+=20',
            end: () => `+=${scrollContent.offsetHeight + window.innerHeight}`,
            pin: pinnedImage,
            pinSpacing: false,
            scrub: 1,
        },
    });
    const mm = gsap.matchMedia();
    mm.add('(min-width: 768px)', () => {
        contentItems.forEach((item, itemIndex) => {
            const multiplier = 1 + itemIndex * 3;
            const yOffset = -100 * multiplier;
            tl.to(item, {
                y: yOffset,
                ease: 'none',
            }, 0);
        });
    });
}
export const scrollyTellAnimationSetup = (gsap, ScrollTrigger) => {
    return window.addEventListener('DOMContentLoaded', () => {
        console.debug('Scrollytell script loaded');
        const scrollyTells = document.querySelectorAll('.spv-campaignPage__scrollytell-block');
        if (!scrollyTells)
            return;
        scrollyTells.forEach(section => {
            createScrollSection(section, gsap);
        });
        window.addEventListener('resize', () => {
            ScrollTrigger.refresh();
        });
    });
};
//# sourceMappingURL=scrollytell.js.map